<template>
  <v-list class="pt-0" dense>
    <v-divider></v-divider>
    <v-list-tile
      v-for="item in visibleItems"
      :key="item.title"
      @click.stop="goTo(item.name)"
    >
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-group
      v-if="newAccount.account_id === 5283"
      false
      prepend-icon="account_balance_wallet"
      style="display: none"
    >
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Conta Digital</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in visibleWallet"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <PaymentIcon v-if="item.usePaymentIcon" :name="item.icon" size="24" />
          <v-icon v-else-if="!item.icon.startsWith('/')">{{ item.icon }}</v-icon>
          <img v-else :src="item.icon" width="24" height="24" :alt="item.title" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
    <!-- else -->
    <v-list-group v-else false prepend-icon="account_balance_wallet">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Conta Digital</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in visibleWallet"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <PaymentIcon v-if="item.usePaymentIcon" :name="item.icon" size="24" />
          <v-icon v-else-if="!item.icon.startsWith('/')">{{ item.icon }}</v-icon>
          <img v-else :src="item.icon" width="24" height="24" :alt="item.title" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
    <!-- <v-list-group false prepend-icon="pix">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Pix {{ appName }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in qrlist"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group> -->

    <v-list-group false prepend-icon="assignment_ind">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Minha Conta</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="account in accounts"
        :key="account.title"
        @click.stop="goTo(account.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ account.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ account.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
  </v-list>
</template>
<script>
import { mapGetters } from "vuex";
import PaymentIcon from '@/components/PaymentIcon.vue';

export default {
  name: "SidemenuItems",
  components: {
    PaymentIcon
  },
  created() {
    this.$store.dispatch("account/getAccount");
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      systemAppName: "system/appName",
      can: "account/can",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
    visibleItems() {
      return this.items.filter((i) => !i.capability || this.can(i.capability));
    },
    visibleWallet() {
      return this.wallet.filter((i) => !i.capability || this.can(i.capability));
    },
  },
  watch: {
    account(newValues) {
      this.newAccount = newValues;
    },
  },
  data() {
    return {
      newAccount: {},
      items: [
        { title: "Dashboard", icon: "dashboard", name: "dashboard" },
        { title: "Minhas vendas", icon: "payment", name: "sales", capability: "view_reports" },
        { title: "Recebíveis", icon: "local_atm", name: "receivables", capability: "view_reports" },
        { title: "Disputas", icon: "money_off", name: "chargebacks", capability: "view_reports" },
        { title: "Antecipações", icon: "list_alt", name: "anticipations", capability: "anticipations" },
        { title: "Central de Soluções", icon: "chat", name: "tickets" },
        { title: "Calculadora", icon: "exposure", name: "taxes" },
        { title: "Operadores e Perfis", icon: "group", name: "team", capability: "manage_users" },
      ],
      wallet: [
        { title: "Extrato", icon: "receipt", name: "wallet", capability: "view_reports" },
        { title: "Meu QRcode", icon: "memory", name: "qrcode" },
        { title: "PagLink", icon: "link", name: "internet", capability: "paylinks" },
        { title: "Venda Digitada", icon: "keyboard", name: "manual", capability: "paylinks" },
        { title: "Pag Recorrente", icon: "repeat", name: "subscriptions", capability: "paylinks" },
        { title: "Pag Recargas", icon: "smartphone", name: "recharges", capability: "recharge" },
        { title: "Boleto Bancário", icon: "view_day", name: "boleto", capability: "paylinks" },
        {
          title: "Pagamento de Contas",
          icon: "camera_alt",
          name: "bill-payments",
          capability: "pay_bills",
        },
        {
          title: "Pagamento DARF",
          icon: "account_balance",
          name: "darf-payments",
          capability: "pay_bills",
        },
        {
          title: "Pagamento PIX",
          icon: "pix",
          name: "pix-payments",
          usePaymentIcon: true,
          capability: "pay_bills",
        },

        // { title: 'Depósito eletrônico', icon: 'storefront', name: 'eletronicPayments' },
        // { title: 'Saque eletrônico', icon: 'storefront', name: 'eletronicReceipts' },
      ],
      // qrlist: [
      //   { title: "Transferir", icon: "move_down", name: "qrcode" },
      //   { title: "Meu Pix {{ appName }}", icon: "pix", name: "qrcode" },
      //   { title: "Pagar com QRCode", icon: "memory", name: "qrcode" },
      // ],
      calculator: [{ title: "Calculadora", icon: "exposure", name: "taxes" }],
      accounts: [
        { title: "Meus Dados", icon: "account_circle", name: "account" },
        {
          title: "Conta de Liquidação",
          icon: "attach_money",
          name: "liquidation-account",
        },
      ],
    };
  },
  methods: {
    goTo(route) {
      // Evitar navegação desnecessária se já estamos na rota atual
      if (this.$route.name !== route) {
        this.$router.push({ name: route });
      }
    },
  },
};
</script>

<style>
.myaccount-icon {
  padding-right: 13px;
}
.liquidationaccount-icon {
  padding-right: 13px;
}

/* Ajustar cor do ícone PIX no menu para seguir padrão Vuetify */
.v-list-tile-action .payment-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

/* Dark theme support */
.theme--dark .v-list-tile-action .payment-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>
